export const none = <>&mdash;</>;
